import React, { useState } from 'react';
import { supportService } from '../../../../services/SupportService';
import keycloak from '../../../../services/Keycloak';

export default function PritsetSupportWidget() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!form.message) {
      alert('Please fill all fields');
      return;
    }

    setLoading(true);

    await supportService.sendMessage(
      `${keycloak.tokenParsed['given_name']} ${keycloak.tokenParsed['family_name']}`,
      keycloak.tokenParsed['email'],
      form.message,
    );

    setLoading(false);
    setForm({
      name: '',
      email: '',
      message: '',
    });
    setOpen(false);
    alert("Message sent! We'll contact you soon.");
  };

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-6 right-6 bg-indigo-600 hover:bg-indigo-700 text-white p-4 rounded-full shadow-xl transition duration-200"
      >
        💬
      </button>

      {/* Modal */}
      {open && (
        <div className="fixed bottom-20 right-20 w-96 bg-white rounded-2xl shadow-2xl border border-gray-200 p-6">
          <h3 className="text-xl font-semibold mb-4 text-gray-800">Ask Pritset Support</h3>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* <input
              type="text"
              placeholder="Your Name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
            /> */}

            {/* <input
              type="email"
              placeholder="Your Email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
            /> */}

            <textarea
              rows={4}
              placeholder="Your message..."
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
            />

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-lg transition duration-200 disabled:opacity-50"
            >
              {loading ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>
      )}
    </>
  );
}
